import React from 'react';
import _ from 'lodash';
import { browserHistory, Link } from 'react-router';
import { fetchCamGroup, fetchFeed, fetchLiveCamInfo } from './camgroups';
import { setCurrentSection, resetBackgroundImageCache } from './globalConfig';
import { fetchRelatedSnapshotFeed } from './relatedSnapshots';
import { setAlert, setAlerts, clearOtherCamAlerts } from './alerts';
import { setErrorMessage } from './errors';
import { parseJSON, checkHttpStatus } from '../utils';

import {
  CURRENT_ITEM_REQUEST,
  CURRENT_ITEM_FAILURE,
  CURRENT_ITEM_SUCCESS,
  // CURRENT_ITEM,
  SET_CURRENT_ITEM,
  SET_CURRENT_ITEM_BY_SLUG,
  // SET_CURRENT_ITEM_BY_FEED,
  SET_CURRENT_ITEM_BY_USERNAME,
  SET_SELECTED_ITEM,
  LIVECAM_CLICK_TRACKER, SET_IS_LIVE_STATUS,
} from '../constants';
import ExploreAuth from '../utils/ExploreAuth';
import fetch from 'isomorphic-fetch';

export function livecamClickTracker() {
  return (dispatch, getState) => {
    const state = getState();
    if (state.auth.promptRegistration && state.currentItem.livecamClicks < 3) {
      return dispatch({ type: LIVECAM_CLICK_TRACKER });
    }
    return undefined;
  };
}

export function setSectionTitleFromCamgroup(camgroup) {
  const clearFocus = function (e) {
    e.target.blur();
  };
  return (
    <span>
      <Link onClick={clearFocus} to="/livecams">
        Livecams
      </Link>{' '}
      /{' '}
      <Link onClick={clearFocus} to={`/livecams/${camgroup.slug}`}>
        {camgroup.title}
      </Link>
    </span>
  );
}

export function currentItemSuccess(data) {
  return async (dispatch, getState) => {
    const state = getState();
    const selectedItem = state.currentItem.selectedItem;
    if (selectedItem && selectedItem !== data.id) return null;
    setSectionTitleFromCamgroup(data.cam_group);

    let nonPrimaryFeeds = [];

    if (data.cam_group.multi_livecam) {
      const fetchPromises = data.feeds
        .filter(item => item.id !== data.id)
        .map((item) => {
          return fetchLiveCamInfo(item.id);
        });
      await Promise.all(fetchPromises).then((results) => {
        nonPrimaryFeeds = results;
      });
    }

    return dispatch({
      type: CURRENT_ITEM_SUCCESS,
      payload: { data, nonPrimaryFeeds },
    });
  };
}

export function setIsLive(liveState) {
  return (dispatch) => {
    return dispatch({
      type: SET_IS_LIVE_STATUS,
      payload: liveState,
    });
  };
}

export function setCurrentItemLogic(currentItemId, params) {
  return (dispatch, getState) => {
    const state = getState();
    const currentCamgroup = state.cam_groups.data.find((group) => {
      if (!parseInt(currentItemId, 10)) {
        return String(group.id).toLowerCase() === currentItemId.toLowerCase();
      }
      return group.id === currentItemId;
    });
    let currentItem = null;
    const { slug, feedId } = params;

    if (
      _.isNil(currentCamgroup)
      || _.isNil(currentCamgroup.feeds)
      || _.isEmpty(currentCamgroup.feeds)
    ) {
      dispatch(setErrorMessage({ id: 1, message: 'Could not load feed.' }));
      dispatch(currentItemSuccess(state.globalConfig.defaultItem));
      return;
    }

    if (!currentCamgroup.multi_livecam) {
      dispatch(fetchRelatedSnapshotFeed(currentCamgroup.id));
    }

    if (slug && slug.mediaobject) {
      currentItem = currentCamgroup.feeds
        .filter(item => item.slug === slug.mediaobject)
        .shift();
    } else {
      currentItem = currentCamgroup.feeds
        .map((item) => {
          if (feedId) {
            if (item.id === feedId) {
              return item;
            }
          } else if (item.primary_feed) {
            return item;
          }
        })
        .filter((item) => {
          return item;
        })
        .shift();
    }

    // If current item doesn't exist, set a message and load default feed from camgroup
    if (_.isNil(currentItem)) {
      dispatch(
        setErrorMessage({
          id: 2,
          message: 'Feed could not be found in Camgroup. Going to default feed.',
        }),
      );
      currentItem = currentCamgroup.feeds
        .filter((item) => {
          return item.primary_feed;
        })
        .shift();

      currentItem = currentItem || currentCamgroup.feeds.shift();
    }

    if (currentCamgroup.channel) currentItem.channel = currentCamgroup.channel;
    currentItem.feeds = currentCamgroup.feeds;
    currentItem.cam_group_title = currentCamgroup.title;
    currentItem.cam_group = currentCamgroup;

    dispatch(currentItemSuccess(currentItem));
    dispatch(
      setCurrentSection(setSectionTitleFromCamgroup(currentItem.cam_group)),
    );
    dispatch(resetBackgroundImageCache());
    dispatch(clearOtherCamAlerts(currentItem.id));
    if (!_.isEmpty(currentItem.alert)) {
      dispatch(setAlert(currentItem.alert));
    }
    if (!_.isEmpty(currentItem.alerts)) {
      dispatch(setAlerts(currentItem.alerts));
    }
    // dispatch(relatedSnapshotsFeedSuccess(currentItem.feeds));
  };
}

export function setCurrentItem(id, state, feedId) {
  return (dispatch, getState) => {
    dispatch({ type: SET_CURRENT_ITEM });
    let currentCamgroup = _.find(state, { id });

    const params = { feedId };

    checkCamGroup(currentCamgroup, id, dispatch).then(() => {
      const currentState = getState();
      currentCamgroup = _.find(currentState.cam_groups.data, { id });
      const feed = getFeedOrPrimary(currentCamgroup.feeds, { id: feedId });
      checkFeed(feed, currentCamgroup.id, dispatch).then(() => {
        dispatch(setCurrentItemLogic(currentCamgroup.id, params));
      });
    });
  };
}
export function currentItemFailure(error, message) {
  return {
    type: CURRENT_ITEM_FAILURE,
    payload: {
      status: error,
      statusText: message,
    },
  };
}

export function currentItemRequest() {
  return {
    type: CURRENT_ITEM_REQUEST,
  };
}

export function setSelectedItem(feedId) {
  return {
    type: SET_SELECTED_ITEM,
    payload: {
      selectedItem: feedId,
    },
  };
}

function checkCamGroup(camGroup, camgroupId, dispatch, user) {
  if (_.isNil(camGroup) || !_.isEmpty(camGroup.feeds)) {
    if (!user) {
      user = camGroup ? camGroup.user : _.isNaN(parseInt(camgroupId));
    }
    return dispatch(fetchCamGroup(camgroupId, user));
  }

  return Promise.resolve();
}

function checkFeed(feed, groupId, dispatch) {
  dispatch(setSelectedItem(feed.id));
  if (!feed.description) {
    return dispatch(fetchFeed(feed.id, groupId));
  }
  return Promise.resolve();
}

function getFeedOrPrimary(feeds, feedQuery) {
  let feed = _.find(feeds, feedQuery);
  feed = feed || _.find(feeds, { primary_feed: true });
  return feed || _.first(feeds);
}

export function setCurrentItemBySlug(slug, state) {
  return (dispatch, getState) => {
    dispatch({ type: SET_CURRENT_ITEM_BY_SLUG });
    let currentCamgroup = _.find(state, { slug: slug.group });
    const params = { slug };

    checkCamGroup(
      currentCamgroup,
      _.get(currentCamgroup, 'id', null),
      dispatch,
    ).then(() => {
      const currentState = getState();
      currentCamgroup = _.find(currentState.cam_groups.data, (group) => {
        const currentSlug = slug.group || '';
        const groupsSlug = group.slug || '';
        return groupsSlug.toLowerCase() === currentSlug.toLowerCase();
      });
      const feed = getFeedOrPrimary(currentCamgroup.feeds, {
        slug: slug.mediaobject,
      });
      checkFeed(feed, currentCamgroup.id, dispatch).then(() => {
        dispatch(setCurrentItemLogic(currentCamgroup.id, params));
      });
    });
  };
}

export function setCurrentItemByUsername(slug, state) {
  return (dispatch, getState) => {
    dispatch({ type: SET_CURRENT_ITEM_BY_USERNAME });
    let currentCamgroup = _.find(state, { slug: slug.group });
    const params = { slug };

    checkCamGroup(
      currentCamgroup,
      _.get(currentCamgroup, 'id', slug.group),
      dispatch,
      true,
    ).then(() => {
      const currentState = getState();
      currentCamgroup = _.find(currentState.cam_groups.data, (group) => {
        return String(group.id).toLowerCase() === slug.group.toLowerCase();
      });
      if (!currentCamgroup || !currentCamgroup.feeds) {
        return browserHistory.push('/livecams');
      }

      const feed = getFeedOrPrimary(currentCamgroup.feeds, {
        slug: slug.mediaobject,
      });
      if (!feed) {
        return browserHistory.push('/livecams');
      }
      checkFeed(feed, currentCamgroup.id, dispatch).then(() => {
        dispatch(setCurrentItemLogic(currentCamgroup.id, params));
      });
    });
  };
}

export function setCurrentItemDirectly(slug) {
  return (dispatch, getState) => {
    const state = getState();
    const user = state.auth.userId;
    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        return fetch(`${SERVER_URL}/livecams/preview/${slug}`, {
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
        }).then(checkHttpStatus)
          .then(parseJSON)
          .then(({ data }) => {
            dispatch(setSelectedItem(data.id));
            return dispatch(currentItemSuccess(data));
          });
      });
  };
}
